import { render, staticRenderFns } from "./CheckboxListView.vue?vue&type=template&id=d20b6d52&"
import script from "./CheckboxListView.vue?vue&type=script&lang=ts&"
export * from "./CheckboxListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports